import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Cloudinary from 'cloudinary-vue';
import CookieLaw from 'vue-cookie-law'
/* import VueAnalytics from 'vue-analytics'; */
const fb = require('./firebaseConfig.js')

Vue.config.productionTip = false
Vue.use(CookieLaw)
/* Vue.use(VueAnalytics, {
  id: '239529887',
  router
}) */
Vue.use(Cloudinary, {
  configuration: {
    cloudName: "dkq6zer55"
  }
})

let app
fb.auth.onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      el: '#app',
      router,
      store,
      user,
      render: h => h(App)
    })
  }
})